/** Imperative navigate hook for native push taps before route guards mount. */
export type AppNavigate = (path: string) => void;

let navigateFn: AppNavigate | null = null;
let pendingPath: string | null = null;
let lastNavigation: { path: string; at: number } | null = null;

export function setAppNavigate(fn: AppNavigate | null) {
  navigateFn = fn;
  if (fn && pendingPath) {
    const path = pendingPath;
    pendingPath = null;
    fn(path);
  }
}

export function navigateFromPush(path: string) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const now = Date.now();
  if (
    lastNavigation &&
    lastNavigation.path === normalized &&
    now - lastNavigation.at < 2000
  ) {
    return;
  }
  lastNavigation = { path: normalized, at: now };

  if (navigateFn) navigateFn(normalized);
  else pendingPath = normalized;
}

/** Client-side route change from native link interception. */
export function navigateInApp(path: string) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (navigateFn) navigateFn(normalized);
  else pendingPath = normalized;
}
